import { AutoMap } from "@automapper/classes";
import { ObservationDto } from "./observation.dto";

export class ObservationResponseAllDto {

    @AutoMap()
  public content!: ObservationDto[];
}